import * as React from 'react';

import CollapsibleContentFull from './CollapsibleContentFull';
import CollapsibleContentIntro from './CollapsibleContentIntro';

interface Props {
    showLabel: string;
    hideLabel: string;
    clsNames: Array<string>; //@deprecated
    className: string;
    forceShow: boolean;
}

interface State {
    collapsed: boolean;
}

export default class CollapsibleContent extends React.PureComponent<Props, State> {
    static defaultProps = {
        showLabel: 'Show More',
        hideLabel: 'Show Less',
        forceShow: false,
        clsNames: [],
        className: '',
    };

    constructor(props: Props) {
        super(props);

        this.state = {
            collapsed: !props.forceShow,
        };
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        const { forceShow } = this.props;

        if (forceShow !== prevProps.forceShow) {
            this.setState({
                collapsed: !forceShow,
            });
        }
    }

    isReactElementLike = (component: React.ReactNode): component is React.ReactElement => {
        return !!component && typeof component === 'object' && (component as React.ReactElement).type !== 'undefined';
    };

    handleToggleClick = (evt: React.MouseEvent): void => {
        this.setState((prevState, preProps) => ({
            collapsed: !prevState.collapsed,
        }));
    };

    render() {
        const { collapsed } = this.state;
        const { clsNames, className, children, showLabel, hideLabel, forceShow } = this.props;

        let introComponentNode: React.ReactNode | null = null;
        let fullComponentNode: React.ReactNode | null = null;
        React.Children.forEach(children, (component) => {
            if (this.isReactElementLike(component)) {
                if (component.type === CollapsibleContentIntro) {
                    introComponentNode = component;
                }
                if (component.type === CollapsibleContentFull) {
                    fullComponentNode = component;
                }
            }
        });

        let conClassNames: Array<string> = [className, 'collapsible-content', 'ddbc-collapsible-content'];
        if (clsNames.length) {
            conClassNames = [...clsNames, ...conClassNames];
        }
        if (collapsed) {
            conClassNames.push('collapsible-content-collapsed');
            conClassNames.push('ddbc-collapsible-content--is-collapsed');
        } else {
            conClassNames.push('collapsible-content-opened');
            conClassNames.push('ddbc-collapsible-content--is-opened');
        }

        return (
            <div className={conClassNames.join(' ')}>
                {introComponentNode}
                {!collapsed && fullComponentNode}
                {!forceShow && (
                    <div
                        className="collapsible-content-trigger ddbc-collapsible-content__trigger"
                        onClick={this.handleToggleClick}
                    >
                        {collapsed ? showLabel : hideLabel}
                    </div>
                )}
            </div>
        );
    }
}
